// add your site specific javascript here
window.mobileCheck = function() {
  let check = false;
  (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
  return check;
};
window.mobileAndTabletCheck = function() {
  let check = false;
  (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
  return check;
};
(function ( $ ) {
	'use strict';

	$.ajaxSetup( {
		cache: true
	} );

	
	//For crawler
	if ( !window.JS_ENABLED ) {
		$.ajax( {
			url:      window.makeUrl( { module: 'eshop', action: 'setJavascriptEnabled' } ),
			type:     'post',
			dataType: 'json'
		} );
	}
	// -----------------------------------------------------------------------------------------------------------------
	// Anything to be initialized on document ready goes here

	$( function () {
		//menu mobile
		
		$('#navbar-collapse-categories-mobile [data-toggle="collapse"]').on('click',function(e){
			e.stopPropagation();
			if(!$(this).hasClass('collapsed')){
				e.preventDefault();
				$(this).addClass('collapsed');
				$(this).next().removeClass('in');
			}
			
		});
		
		
		//DISABLE PARALLAX FOR SAFARI
		var is_safari = (navigator.userAgent.indexOf('Safari') != -1) && (navigator.userAgent.indexOf('Chrome') == -1);
		if (navigator.userAgent.match(/(iPod|iPhone|iPad)/) || is_safari) {
			$(".dropdown-toggle").mouseover(function(e) {
          e.stopPropagation();
			});
		}
		
		//First modal registration
		$( '#registrationModalThanks').modal( 'show' );

		// If we have an "active" tab we start with that one selected, otherwise we select the first one
		$( '.nav-tabs' ).each( function () {
			var $activeTab = $( this ).find( '.active [data-toggle="tab"]:first' );

			if ( $activeTab.length ) {
				$activeTab.tab();
			} else {
				$( this ).find( '[data-toggle="tab"]:first' ).tab();
			}
		} );

		
		
		
		
		
		
		
		
		
		
		
		
		
		
		// Open close tab-pane mobile
		$('.closeTab').click(function(e){
			$('.tabbable .nav li').removeClass('active');
			$('.tabbable .tab-content .tab-pane').removeClass('active');
		});
		
		// Toggle div for address in Account manager
		$(document).on("click", ".openAddress" , function() {
			$(".closeTab").css('display','none!important')
			$(".dynAddress").css('display','block');
			$(".addressList").css('display','none');
		});
		$(document).on("click", ".dynAddress .btn-back" , function() {
			$(".closeTab").css('display','block')
			$(".dynAddress").css('display','none');
			$(".addressList").css('display','block');
		});
		
		
		// Reset form
		$("#resetForm").click(function(){ 
			$("#addressFormNoModal")[0].reset();
		});
		
		// Select Refund/Change product, get the value from a checked checkbox
		$(".inputCheckbox").click( function(){
			var elementId = $(this).attr('id').slice(-1);
			var selectOpt = ("select.sel-" + elementId);
			
			if( $(this).is(':checked') ){
				if ( $(this).val() == 1 ){
					//refund
					$( selectOpt ).val("refund").change();
				} else {
					//exchange
					$( selectOpt ).val("exchange").change();
				}
			} else {
				$( selectOpt ).val("").change();
			}
		});
		
	
	// Carousel Settings - Home
	
	} );

	$( function () {
		$( this ).find( '[data-zg-role="search-input"]').each( function(){
				//Bind the search function
				$( this ).on('input paste', function(){


					// Retrieve the input field text and reset the count to zero
					var filter = $(this).val(), count = 0;

					// Loop through the comment list
					$('[data-zg-role="search-items"]').each(function(){

						// If the list item does not contain the text phrase fade it out
						if ($(this).text().search(new RegExp(filter, "i")) < 0) {
							$(this).fadeOut();

							// Show the list item if the phrase matches and increase the count by 1
						} else {
							$(this).show();
							count++;
						}
					});

					// Update the count
					if(count > 0){
						$("#noResult").addClass('hide');
					}
					else{
						$("#noResult").removeClass('hide');
					}
					$("#filter-count").text(count);
					$(".count-hide").removeClass('hide');

				});
			}
		);

	});

	//Scroll slowly to the target
	$( function () {
		$('[data-zg-scrollTo="slowly"]').click(function (e) {
			e.preventDefault();
			var target = $(this).data('zg-target');
			var top=$(target).offset().top;
			if($('.manager_category').length !==0 || $('.manager_product').length !==0){
		
				top=top-100;
			}
			if($('.manager_home').length !==0){
				top=0;
			}
			//console.log(top);
			
			//href = $(this).attr("href");
			$('html, body').animate({scrollTop: top}, 1000);
			
			//window.location.hash = href;
		});
		
	});
	
	
	
	
	
		

	
	$(window).scroll(function(e){
		var $el = $('.onTop'); 
		if ($(this).scrollTop() > 300){ 
			$el.removeClass('hidden'); 
		}
		if ($(this).scrollTop() < 300)
		{
			$el.addClass('hidden'); 
		} 
		
		if($('.checkout-fixed').length){
			var $barcheckout = $('.checkout-fixed'); 
			if ($(this).scrollTop() > 100){ 
				$barcheckout.addClass('up'); 
			}
			if ($(this).scrollTop() < 100)
			{
				$barcheckout.removeClass('up'); 
			}
		}
	});
	

	
	
	
	
	$( document ).on('[data-zg-role="reset-filters"]','click', function(){
			$( document ).trigger('zg.filter.applyFilters');
	});
	//ON CART LOAD AND WISH
	$( document ).on( 'zg.getProductList.updated',function(){
		//console.log($('[data-zg-collapse="collapse"]').length);
		$('[data-zg-collapse="collapse"]').on('click', function(e){
			e.preventDefault();
			e.stopPropagation();
			$(this).addClass('hidden')
			$('.'+$(this).attr('data-zg-target')).removeClass('hidden');
		});
	});
})( jQuery );
// -----------------------------------------------------------------------------
// STORE LOCATOR LIST
// HIDE RESULTS IF NO FILTERS ARE APPLIED

(function ($) {
    'use strict';
	$(document).on('click','#sl-container [data-zg-role="reset-filters"]',function(e){
		setTimeout(function(){
			$( document ).trigger( 'storeReset');
		},800);
	});
	$(document).on('focus','#store-locator [data-zg-role="filter-search"]',function(e){
		$('[data-zg-role="filter-search"]').val('')
	});

    $(function () {
        var $filtersStores = $('#sl-filter-container');
        var $paginationStores = $('#sl-stores-container');

        $filtersStores.on('applyFilters', function (e, appliedFilters) {
            const searchValue = $('[data-zg-role="filter-search"]').val() || '';
			if (Object.keys(appliedFilters).length >= 1 || searchValue.length !== 0) {
				$paginationStores.removeClass('hidden');
			} else {
				$paginationStores.addClass('hidden');
			}
        });
    });
})(jQuery);

/*
$( document ).on( 'applyFilters',function(){
	console.log("applyFilters");
	if($('[data-zg-role="selected-filter"]').length){
		$( '[data-zg-role="selected-filter"]' ).text('');
		$('#filter-container .content-filter .active').each(function(){
			if($(this).data('zg-action')!== "reset"){
				var $this=$(this).clone();
				var $t=$(this);
				$( '[data-zg-role="selected-filter"]' ).append( $this );
				$this.on('click',function(e){
					e.preventDefault();
					e.stopPropagation();
					$t.click();
				});
			}
		});
		// data-role="rangeslider" #range-1a #range-1b (min max value)
		if(
			$('[data-role="rangeslider"] #range-1a').attr('min') !==  $('[data-role="rangeslider"] #range-1a').attr('value') || 
			$('[data-role="rangeslider"] #range-1b').attr('max') !==  $('[data-role="rangeslider"] #range-1b').attr('value') 
			){
				
				var $filterPrice='<a class="txt-filter price-filter">'+$('[data-role="rangeslider"] #range-1a').attr('value')+' - '+$('[data-role="rangeslider"] #range-1b').attr('value')+'</a>' ;
				$( '[data-zg-role="selected-filter"]' ).append( $filterPrice );
				$('.price-filter').on('click',function(){					
					$('[data-role="rangeslider"]').trigger('reset');
				});
				$('.selected-filter').removeClass('hidden');
				var $delete='<div class="visible-xs removeAllFilters pull-right">x</div>';				
				$( '[data-zg-role="selected-filter"]' ).append( $delete );
				$('.removeAllFilters').on('click',function(){
					$('.selected-filter a').each(function(){
						$(this).trigger('click');
					});
				});
		}else{
			if($('#filter-container .filter.panel .content-filter .active').not('[data-zg-action="reset"]').length===0){
				$('.selected-filter').addClass('hidden');
			}else{
				$('.selected-filter').removeClass('hidden');
				var $delete='<div class="visible-xs removeAllFilters pull-right">x</div>';
				$( '[data-zg-role="selected-filter"]' ).append( $delete );
				$('.removeAllFilters').on('click',function(){
					$('.selected-filter a').each(function(){
						$(this).trigger('click');
					});
				});
			}			
		}
	}else{
		$('.selected-filter').addClass('hidden');				
	}
	
});
*/

/*to close the options when click out*/
$(document).mouseup(function (e) {
   if (!$('.product-filters').is(e.target) // if the target of the click isn't the container...
   && $('.product-filters').has(e.target).length === 0) // ... nor a descendant of the container
   {
     $('.product-filters').parent('.btn-group-toggle').find('[data-zg-role="selected-single-combination"]').not('.collapsed').click();
  }
 });






// register page
if ( $('[data-zg-role="register-area"]').length ) {
	$('[data-zg-role="register-area"]').hide();
	$('[data-zg-role="guest-area"]').hide();
	$(document).on("click",'[data-zg-role="register-btn"]',function(e) {
			e.preventDefault();
			$('[data-zg-role="login-area"]').hide();
			$('[data-zg-role="register-area"]').show();
	});

	$(document).on("click",'[data-zg-role="guest-btn"]',function(e) {
			e.preventDefault();
			$('[data-zg-role="login-area"]').hide();
			$('[data-zg-role="guest-area"]').show();
	});

	$(document).on("click",'[data-zg-role="back-register"]',function(e) {
			e.preventDefault();
			$('[data-zg-role="login-area"]').show();
			$('[data-zg-role="register-area"]').hide();
	});

	$(document).on("click",'[data-zg-role="back-guest"]',function(e) {
			e.preventDefault();
			$('[data-zg-role="login-area"]').show();
			$('[data-zg-role="guest-area"]').hide();
	});
}

if ( $('.input-group input,.input-group textarea,.input-group select').length ) {
	$(document).on("focus", '.input-group input,.input-group textarea,.input-group select',function(e) {
		$(this).closest( ".input-group" ).addClass('focused');
	});
	
}	



// ############################################
// ########## VIDEO FULLSCREEN TRICK ##########
// ############################################

function videoSize() {
  var $windowHeight = $(window).height();
  var $videoHeight = $(".video").outerHeight();
	var $scale = $windowHeight / $videoHeight;
  
  if ($videoHeight <= $windowHeight) {
    $(".video").css({
      "-webkit-transform" : "scale("+$scale+") translateY(-50%)",
			"transform" : "scale("+$scale+") translateY(-50%)"
		});
	};
}

$(window).on('load resize',function(){
  videoSize();
});









$(document).on('click', '[data-zg-role="scroll-to"]' ,function(){
  var id = $(this).data('id');
	var classId = $(this).data('class');
	if(classId){
		$('html,body').animate({
    	scrollTop: $('.'+ classId).offset().top-150
  	},'slow');
	}
	if(id){
		$('html,body').animate({
    	scrollTop: $('#'+id).offset().top-150
  	},'slow');
	}
});
$(document).on('focus', '[name="frmEmail"]' ,function(){
	//console.log('chenge');
	if($('.checkbox.collapse')){
		//console.log('collapse on');
		$('.checkbox.collapse').addClass('in');
	}
});


$(document).on('submit', '[data-zg-role="landing-newsletter"]' ,function(e){
	
	if( $(this).find('#frmEmail').val() == '' || $(this).find('[name="check-page"]').prop('checked') == false){
		
		if($(this).find('#frmEmail').val() == '') $(this).find('#frmEmail').focus();
		
	 return false;
	}
	
});
/*SCRIPT to close macro category opened via html*/
var timeoutMenu;
//if in main category page
if($('.main-category-menu').length != 0){
	timeoutMenu=setTimeout(function(){
		$('.category-menu').removeClass('on');
	},1500);
}
$('#navbar-collapse-categories').mouseenter(function() {
	clearTimeout(timeoutMenu);
});
$('#navbar-collapse-categories').mouseleave(function() {
	clearTimeout(timeoutMenu);
});
//MENU MANAGER VISIBILITY
$('.category-menu').mouseleave(function() {
	$('.category-menu').removeClass('on');
});






	

$('.manager_product .left img'   ).on( 'load',function(e){
	$this = $(this);
	setTimeout(function(){
		$this.css({'width' : '100%', 'height' :'auto'});
		$this.css({'width' : $this.innerWidth(), 'height' : $this.innerHeight()});
	},1500);
} );
//FIX FOR double image 
$( document ).ready(function() {
	if($('.double_images').length != 0){
		if($('.double_images').innerHeight() >= $('.double_images').innerWidth()){
			console.log('DOUBLE IMAGE MOBILE');
			$('.double_images .div-left').css('top', '0');
			$('.double_images .div-left').css('bottom', '50%');
			$('.double_images .div-left').css('left', '0');
			$('.double_images .div-left').css('width', '80%');
			
			
			$('.double_images .div-right').css('top', '50%');
			$('.double_images .div-right').css('bottom', '0');
			$('.double_images .div-right').css('width', '80%');
			$('.double_images .div-right').css('right', '0');
			$('.double_images .div-right').css('left', 'auto');
			if(IS_MOBILE){
				$('.double_images .div-left').css('width', '100%');
				$('.double_images .div-right').css('width', '100%');
			}	
		}
	}
})

//flagship-carousel
$( document ).ready(function() {
	if ($('#flagship-carousel').length > 0) {

		var url = window.RANDOM_IMG_ROOT + '/themes/' + window.SGL_JS_MERCHANT_ID + '/' + window.SGL_JS_THEME + '/js/lib/slick.min.js';
		$.getScript( url, function() {
		
			$('#flagship-carousel').slick({
				dots: true,
  				infinite: true,
				slidesToShow: 3,
				slidesToScroll: 1,
				arrows: true,
				
				responsive: [
					{
						breakpoint: 768,
						settings: {
							slidesToShow: 2
						}
					},
					{
						breakpoint: 480,
						settings: {
							slidesToShow: 1
						}
					}
				]
			});


		});



	
	}
});


$(window).on('load', function() {
	var video = $('.manager_product video.product-video');
	/*console.log('on load -- video', video)*/
	
	if (video.length > 0) {
		video.each(function() {
			this.play();
		})
	}
	/*POPUP HOME*/
	if(zgReadCookie('popup_home') != 1){
		if($('#countrypopUp')){
			$('#countrypopUp').modal("show");
			zgCreateCookie('popup_home','1',1);
		}
	}
});

$( document ).ready(function() {
	if ($('#products-container').length > 0) {
		$( document ).on('mouseover','.product-preview>article.panel', function(){
			$( this ).find('.image-option img').each(function( index ) {
  				$( this ).attr('src', $( this ).data('src') );
			});
		});
	}
});

//newsletter AJAX
$( document ).on('ready', function() {

	/*ontrust trick to change lang*/
	/*
	var checkLang=0;
	if($('[data-onetrust-lang="IT"]').length != 0){
		$('[data-onetrust-lang="IT"]').html('Cookie Settings');
		$('[data-onetrust-lang="IT"]').on('DOMSubtreeModified', function(){
			if(checkLang == 0){
				checkLang=1;
				$('[data-onetrust-lang="IT"]').html('Cookie Settings');
				$('[data-onetrust-lang="IT"]').off('DOMSubtreeModified');
			}
		});
	}
	*/
	/*NL */
	var forms = $('#newsletter_form_footer, #newsletter_form_component')
	/*console.log('initNl', forms)*/
	
	forms.each(function (index, el) {
		var clearEmailInput = function() {
			$(el).find('input[type="email"]').val('')
		}
		
		var privacyField = $(el).find('input[name="check-footer"], input[name="check-component"]')
		var action = $(this).attr('action')
		
		$(el).on('submit', function(e) {

			e.preventDefault()
			if(privacyField.is(':checked')) {
				if($(el).valid()) {
					var dataArray = $(this).serializeArray()
					var formData = new FormData(this)

					$.ajax({
						url: action,
						type: 'POST',
						cache: false,
						dataType: "html",
						data: $(this).serialize(),
						contentType: 'application/x-www-form-urlencoded',		

						beforeSend: function ( xhr ) {
							xhr.setRequestHeader('X-Requested-With', 'empty');
						},
					})

					.done(function(response, status) {
						var htmlResponse = $(response)
						var alreadyregistered = htmlResponse.find('.user-already-registered').length > 0

						if (alreadyregistered) {
							$.gritter.add( {
								title:      window.JS_TRANSLATIONS['notifier.notification'] || 'Notification',
								class_name: 'alert alert-success',
								text: 	JS_TRANSLATIONS.already_nl_ok.substring( 0, 40 ),
								time: 1000000,
							} );

							clearEmailInput()
						} else {
							$.gritter.add( {
								title:      window.JS_TRANSLATIONS['notifier.notification'] || 'Notification',
								class_name: 'alert alert-success',
								text: 	JS_TRANSLATIONS.nl_email_to_confirm.substring( 0, 40 ),
								time: 1000000,
							} );

							clearEmailInput()
						}
					})

					.error(function (error) {
						console.log('Error', error)
					})
				} else {
					var mailError = $(el).find('#ns_email-error')	
					mailError.css('color', 'red')
					setTimeout(function () {
							mailError.css('color', 'black')
					}, 3000)
				}
			}
		})
	})

})

$(window).on('load', function() {
	var params = new URL(document.location).searchParams;
	var emailConfirmation = params.get("emailConfirmation");
	
	if (!!emailConfirmation) {
		$.gritter.add( {
				title:      window.JS_TRANSLATIONS['notifier.notification'] || 'Notification',
				class_name: 'alert alert-success',
				text: 	JS_TRANSLATIONS.notification_nl_ok.substring( 0, 40 ),
				time: 1000000,
			} );
	}

	$(document).on("click", "#collapseOption2 .btn" , function() {
		$('[data-zg-role="startingfrom"]').hide();
	});


})

$(window).on('load', function() {
	if($('[data-zg-role="countrycost"]').length){
		$( '[data-zg-role="countrycost"]' ).each(function( index ) {
			var $form = $( this );
			$form.on("change", 'select' , function() {
				var $selectedValue = $form.find( 'select option:selected' );
				var shippingCost = $selectedValue.data('shipping');
				var returnCost = $selectedValue.data('return');
				var currency = $selectedValue.data('currency');
				$form.find('[data-zg-role="shipping-fee"]').html(JS_TRANSLATIONS.starting_from + " " + currency + " " + shippingCost);
				$form.find('[data-zg-role="return-fee"]').html(currency + " " + returnCost);
			});
		});
		
	};
});

window.onload = function() {
	/*
	const $opacity0 = document.querySelector('.opacity0');
	if($opacity0){
		$opacity0.style.opacity = '1';
	}
	*/

   //Select all images to be lazy-loaded
   const imgTargets = document.querySelectorAll('.lazy-img');
   
    //Intersection Observer Callback Function
    const loadImg = (entries, observer) => {
		for(const entry of entries){
			if(entry.isIntersecting){
				console.log("intersecting");
				if(entry.target.dataset.src){
					entry.target.src = entry.target.dataset.src;
				}
				else {
					let backgroundPath = entry.target.dataset.background;
					if(screen.orientation.type === 'portrait-primary' && entry.target.dataset.backgroundMobile){
						backgroundPath = entry.target.dataset.backgroundMobile;
					}
					entry.target.style.backgroundImage = `url(${backgroundPath})`;
				}
				entry.target.style.opacity = '1';
				entry.target.classList.remove('height100vh');
				observer.unobserve(entry.target);
			}
		}
    };

   //Create an instance of the IntersectionObserver Object
    const imgObserver = new IntersectionObserver(loadImg,{
        root: null,
        threshold: 0.1,
    })

    //set the images to be observed
    imgTargets.forEach(img => imgObserver.observe(img));
};

// Replacing image source when rotating the viewport
screen.orientation.addEventListener("change", function(e) {
	document.querySelectorAll('.lazy-img').forEach(el => {
		if(el.style.backgroundImage !== '' || el.style.backgroundImageMobile !== ''){
			const backgroundPath = el.dataset.background;
			const backgroundPathMobile = el.dataset.backgroundMobile;
			if(screen.orientation.type === 'portrait-primary'){
				if(backgroundPathMobile){
					el.style.backgroundImage = `url(${backgroundPathMobile})`;
				}
			} else {
				if(backgroundPath){
					el.style.backgroundImage = `url(${backgroundPath})`;
				}
			}
		}
	})
});
$(document).ready(function(){ 
    $('[data-toggle="tooltip"]').tooltip();

	$('[data-zg-role="checklogin"]').click(function(e){
		e.preventDefault();
		e.stopPropagation();
		let $form = $(this).parent('form');
		let action =$form.attr('action')
		/*let data = $form.serializeArray()
		let resultData ={}
		for(var i = 0; i < data.length; i++){

			resultData[data[i].name]= data[i].value
		}
		console.log(resultData,"RESULTDATA : ")

		$.redirect(action, resultData);*/
		let data = $form.serialize()
		location.href=action+'?'+data
	});

});

window.addEventListener('load', function () {

  let orderGetInvoiceButton = document.querySelector('[data-km-role="order-get-invoice"]');

  if (orderGetInvoiceButton !== null) {
    orderGetInvoiceButton.addEventListener('click',orderGetInvoice);
  }

  function orderGetInvoice(e) {

    e.preventDefault();

	const button = e.currentTarget;
  	button.disabled = true;

    const GET_INVOICE_URL = window.makeUrl({
      module: "eshop",
      manager: "order",
      action: "downloadInvoice",
    });

    const params = new URLSearchParams({
      'order_id': Number(this.dataset.orderId),
    });

    const getUrl = `${GET_INVOICE_URL}?${params}`;

    fetch(getUrl,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          'X-Requested-With': "XMLHttpRequest",
        },
      }).then(response => {
      if (!response.ok) {
        return response.json().then((err) => {
          let error = null;
          try {
           error =  new Error(err.message ? window.JS_TRANSLATIONS.get_invoice_error : err);
            if (response.status) {
              error.status = response.status;
            }
          } catch (e) {
          // If JSON.parse failed, or err.message was not present
            let error = new Error(err || `HTTP error ${response.status}`);
            if (response.status) {
              error.status = response.status;
            }
          }
          throw error;
        });
      } else {
        return response.json();
      }
    })
    .then(data => {
      // view invoice new tab.
      window.open(data.download_url, '_blank').focus();
    })
    .catch(err => {
      $(document).trigger('zg-error', [{
        eventType: 'invoice.error',
        message: err.message || JS_TRANSLATIONS.genericErrorMsg,
      }])
    })
	.finally(() => {
		button.disabled = false;
	});

  }

})


	$( '[data-zg-role="change-qty"]' ).click( function(event) {
		event.preventDefault();
		var type = $( this ).data( 'type' );
		var $inputQtySibling = $( this ).parent().siblings( '[data-zg-role="quantity"]' );
		var maxQty = $inputQtySibling.data( 'max' );
		var floatQty = $inputQtySibling.data( 'floatQty' );
		var qty = $inputQtySibling.val();
		var step;

		if( floatQty ){
				step = 0.01;
		}
		else {
				step = 1;
		}
		qty = Number(qty);
		
		$( '[data-zg-role="change-qty"]' ).attr( 'disabled', false );
		if( type == "minus" ){
			//If qty is 0, we will disable the current minus icon. 
			//The next time this function will be run, all the change qty icons will be enabled again.
			if( qty == 0 ){
				$( this ).attr( 'disabled', true );
			}
			else{
				qty = qty - step;
			}
		}
		else {
			//If qty is equal to maxQty, we will disable the current plus icon. 
			//The next time this function will be run, all the change qty icons will be enabled again.
			if( qty == maxQty ){
					$( this ).attr( 'disabled', true );
			}
			else {
				qty = qty + step;
			}
		}

		$( this ).parent().siblings( '[data-zg-role="quantity"]' ).val( qty );
	});



$(document).ready(function() {

    /* ================================================================
    SLIDER PRODOTTI
    - v8.0: Drag state si attiva solo al movimento del mouse
    ================================================================
    */
    $('.products-slider-wrapper, [data-sy="slider"]').each(function() {
    const sliderWrapper = $(this);
    const scrollContainer = sliderWrapper.find('.product-carousel-scroll-container');
    const prevBtn = sliderWrapper.find('.slider-control-prev');
    const nextBtn = sliderWrapper.find('.slider-control-next');

    function setupSlider() {
        const items = sliderWrapper.find('.product-col');
        if (items.length === 0) return;

        const containerWidth = scrollContainer.width();
        let itemWidth;

        // Rimuove eventuali listener precedenti per evitare duplicazioni
        $(document).off('.sliderdrag');
        scrollContainer.off('mousedown');
        prevBtn.off('click');
        nextBtn.off('click');
        
        if ($(window).width() < 992) {
            // --- LOGICA MOBILE ---
            itemWidth = containerWidth / 1.5;
            items.css('width', itemWidth + 'px'); 
            
            nextBtn.on('click', function(e) { 
                e.preventDefault(); 
                scrollContainer.stop().animate({ scrollLeft: scrollContainer.scrollLeft() + itemWidth }, 400); 
            });
            prevBtn.on('click', function(e) { 
                e.preventDefault(); 
                scrollContainer.stop().animate({ scrollLeft: scrollContainer.scrollLeft() - itemWidth }, 400); 
            });

        } else {
            // --- LOGICA DESKTOP ---
            itemWidth = containerWidth / 4;
            items.css('width', itemWidth + 'px');

            let isDown = false;
            let isDragging = false;
            let startX;
            let scrollLeft;

            scrollContainer.on('mousedown', function(e) {
                isDown = true;
                isDragging = false;
                startX = e.pageX - scrollContainer.offset().left;
                scrollLeft = scrollContainer.scrollLeft();

                $(document).on('mousemove.sliderdrag', function(e_move) {
                    if (!isDown) return;
                    e_move.preventDefault();
                    isDragging = true;
                    
                    sliderWrapper.find('.product-col').css('pointer-events', 'none');
                    scrollContainer.addClass('active-drag');
                    
                    const x = e_move.pageX - scrollContainer.offset().left;
                    const walk = x - startX;
                    scrollContainer.scrollLeft(scrollLeft - walk);

                }).on('mouseup.sliderdrag', function() {
                    isDown = false;
                    $(document).off('.sliderdrag');
                    scrollContainer.removeClass('active-drag');
                    
                    if (isDragging) {
                        setTimeout(function() {
                            sliderWrapper.find('.product-col').css('pointer-events', '');
                        }, 100);
                    }
                });
            });
        }
        
			// =========================================================================
			// MODIFICA CHIAVE: Aggiungi la classe per mostrare lo slider
			// Questo viene eseguito solo DOPO che le dimensioni sono state calcolate.
			// =========================================================================
			sliderWrapper.addClass('slider-initialized');
		}
		
		// Inizializza lo slider non appena il DOM è pronto.
		// L'evento 'load' può essere troppo lento, causando il ritardo che noti.
		setupSlider();

		// Ricalcola le dimensioni al resize della finestra (con un debounce)
		let resizeTimer;
		$(window).on('resize', function() {
			clearTimeout(resizeTimer);
			resizeTimer = setTimeout(setupSlider, 250);
		});
	});

    /* ================================================================
    GESTIONE ANCORAGGI E STATO ATTIVO NELLA NAVBAR (INVARIATO)
    ================================================================
    */
    function updateActiveButton() {
        var viewportTop = $(window).scrollTop();
        var viewportBottom = viewportTop + $(window).height();
        var visibleSections = [];

        $('.btn_anchor').each(function() {
            var sectionId = $(this).data('target');
            var section = $(sectionId);
            if (section.length) {
                var sectionTop = section.offset().top;
                var sectionBottom = sectionTop + section.height();
                if (sectionTop < viewportBottom && sectionBottom > viewportTop) {
                    visibleSections.push({ id: sectionId, top: sectionTop });
                }
            }
        });

        if (visibleSections.length > 0) {
            var highestVisibleSection = visibleSections.reduce((prev, curr) => prev.top < curr.top ? prev : curr);
            $('.btn_anchor').removeClass('active');
            $("[data-target='" + highestVisibleSection.id + "']").addClass('active');
        }
    }
    
    updateActiveButton();
    $(window).on('scroll', updateActiveButton);

    $('.btn_anchor').on('click', function(e) {
        e.preventDefault();
        var targetId = $(this).data('target');
        var targetElement = $(targetId);
        if (targetElement.length) {
            $('html, body').animate({ scrollTop: targetElement.offset().top - 100 }, 800);
        }
    });
});



 $(document).ready(function() {
    // Seleziona il contenitore del menu e aggiungi un listener per il click
    $('#pills-tab a').on('click', function(e) {
      // Previene il comportamento predefinito del link
      //e.preventDefault(); 

      // Rimuove la classe 'active' da tutti gli elementi 'nav-link'
      $('#pills-tab a').removeClass('active');

      // Aggiunge la classe 'active' all'elemento cliccato
      $(this).addClass('active');
    });
  });
/*
$(document).ready(function() {
     
    
    // Funzione per nascondere il banner e impostare la scadenza
    

    // --- LOGICA PRINCIPALE ---
    const hideUntil = localStorage.getItem('hideStickyBannerUntil');
    const now = new Date().getTime();

    // Se il banner NON deve essere nascosto...
    if (!hideUntil || now > hideUntil) {
        
        // Aspetta che l'intera pagina sia caricata, poi attendi 5 secondi

			const hideAndSetExpiry = () => {
				const myBannertoClose = $('#sticky-banner-newsletter');
				console.log("close");
				myBannertoClose.removeClass('visible');
				const expiryTime = new Date().getTime() + (7 * 24 * 60 * 60 * 1000);
				localStorage.setItem('hideStickyBannerUntil', expiryTime);

			};
            setTimeout(function() {
				const myBanner = $('#sticky-banner-newsletter');
				const oneTrustSelector = '#onetrust-banner-sdk';
				
                const oneTrustBanner = $(oneTrustSelector);

                // CONTROLLO FINALE:
                // Se il banner OneTrust esiste ed è visibile...
                if (oneTrustBanner.length > 0 && oneTrustBanner.is(':visible')) {
                    // ...calcola la posizione 30px sopra di esso.
                    const oneTrustHeight = oneTrustBanner.outerHeight();
                    const bottomPosition = oneTrustHeight + 30;
                    myBanner.css('bottom', bottomPosition + 'px');
                } 
                // Infine, rendi visibile il banner.
				console.log("myBanner",myBanner);
                myBanner.addClass('visible');
				$('#sticky-banner-newsletter .close svg,#sticky-banner-newsletter .close, #sticky-banner-newsletter .btn').on('click', hideAndSetExpiry);

            }, 5000); // 5000 millisecondi = 5 secondi

    }

    // Gestisci il click sulla "X" di chiusura o sul pulsante
    
});*/

$(document).on('input', '#addr_1, #guestshipping_address_addr_1', function () {

    var $field = $(this);

    // Mostra solo la prima volta per quel campo
    if ($field.data('callout-shown')) return;
    $field.data('callout-shown', true);

    var $callout = $('#address-callout');

    // Posizionamento dinamico
    var offset = $field.offset();

    $callout.css({
        top: offset.top - $callout.outerHeight() - 8,
        left: offset.left
    });

    $callout.fadeIn(200);

    // Nasconde dopo 4 secondi
    setTimeout(function () {
        $callout.fadeOut(300);
    }, 4000);
});